"use client";

import dynamic from "next/dynamic";

/**
 * The app's listeners, for the legal pages when they are being read inside the phone app.
 *
 * Fetched on demand rather than imported outright, and that is the whole point: a static
 * import would put the Supabase browser client into the bundle of every page on the
 * website, which is exactly what this change removed. The chunk is only requested when
 * this renders, and it only renders in the native shell.
 *
 * ssr:false because it has nothing to render on the server. It is listeners, not markup, so
 * it never delays the page itself: the terms are server-rendered as before either way.
 */
const AppRuntimeEffects = dynamic(
  () => import("@/components/app-runtime").then((m) => m.AppRuntimeEffects),
  { ssr: false },
);

export function NativeAppRuntime() {
  return <AppRuntimeEffects />;
}
